import React from "react";
import { Section } from "@/components/app/Primitives";
import { ExceptionList } from "@/components/engage/ExceptionList";

export default function ExceptionInbox() {
  return (
    <div className="space-y-6" data-testid="exception-inbox-page">
      <Section title="Exception Inbox" subtitle="Human-in-the-loop queue — every rule, AI, invoice, pre-flight and KYS failure becomes an assignable, SLA-tracked exception. Assign → Request correction → Resubmit → Review → Approve / Reject → Close." />
      <ExceptionList />
    </div>
  );
}
